import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { REPRESENTANTES_MODALIDES_COMERCIAIS, RepresentanteModalidadeComercialValue } from '../../../domain/representante-modalidade-comercial.enum';

/**
 * Componente para seleção das modalidades comerciais
 *
 * Implementa ControlValueAccessor para integração com ngModel e formulários reativos.
 * Utiliza o array CONCORRENTES_RELEVACIAS para exibir as opções disponíveis.
 *
 */
@Component({
    selector: 'sgt-representante-modalidade-comercial-select',
    templateUrl: './representante-modalidade-comercial-select.component.html',
    styleUrls: ['./representante-modalidade-comercial-select.component.less'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RepresentanteModalidadeComercialSelectComponent),
            multi: true
        }
    ]
})
export class RepresentanteModalidadeComercialSelectComponent implements ControlValueAccessor {
    /** ID da modalidade */
    @Input() ngModel: number;
    /** Ao alterar a modalidade */
    @Output() ngModelChange = new EventEmitter<number>();

    /**
     * ID do elemento select
     * Utilizado para vincular o label ao select através do atributo for
     *
     * @default 'representante-modalidade-comercial'
     */
    @Input() id = 'representante-modalidade-comercial';

    /**
     * Nome do campo no formulário
     * Utilizado para identificação do campo durante a submissão do formulário
     *
     * @default 'representanteModalidadeComercial'
     */
    @Input() name = 'representanteModalidadeComercial';

    /**
     * Indica se o campo é obrigatório
     * Quando true, adiciona o atributo required ao select e exibe um asterisco no label
     *
     * @default false
     */
    @Input() required = false;

    /**
     * Indica se o campo está desabilitado
     * Quando true, impede a interação do usuário com o select
     *
     * @default false
     */
    @Input() disabled = false;

    /**
     * Se pode selecionar nenhuma opção
     */
    @Input() canSelectNull = true;

    /**
     * Label para a opção de selecionar a opção nula
     */
    @Input() nullLabel = 'NENHUMA MODALIDADE'

    /**
     * Se deve setar o focus automaticamente
     */
    @Input() autofocus = false;

    /**
     * Array de opções das modalidades comerciais que serão exibidas no select
     */
    modalidades: RepresentanteModalidadeComercialValue[] = REPRESENTANTES_MODALIDES_COMERCIAIS;

    /** Elemento do select */
    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};


    constructor() { }

      /** Ao alterar a modalidade */
      onChange(modalidade: number) {
        this.ngModel = modalidade;
        this.propagateChange(this.ngModel);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
